import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Logs the user out of all Trimble Maps products
 * @param authToken authenticationToken
 */
export function postLogout(this: unknown, authToken: string) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).securityLogoutUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      credentials: 'include',
      body: JSON.stringify({ authToken }),
    })
  ).pipe(ignoreData());
}
